import { render, staticRenderFns } from "./email-verification-invalid.html?vue&type=template&id=d33f9a0e&scoped=true&"
import script from "./email-verification-invalid.js?vue&type=script&lang=js&"
export * from "./email-verification-invalid.js?vue&type=script&lang=js&"
import style0 from "./email-verification-invalid.scss?vue&type=style&index=0&id=d33f9a0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33f9a0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
